export default "__VITE_ASSET__B5swUvH2__"